import axios from 'axios'

export class NotificationApi {
    static async list({ page } = {}) {
        const response = await axios.get(route('api.notification.index'), { params: { page } })
        return response.data
    }

    static async count() {
        const response = await axios.get(route('api.admin.notification.count'))
        return response.data.count
    }

    static async destroy(id) {
        const response = await axios.delete(route('api.notification.destroy', [id]))
        return response.data
    }

    static async destroyAll() {
        const response = await axios.post(route('api.notification.deleteAll'))
        return response.data
    }
}
